import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import NavItem from './NavItem'
import { getNavItems } from './nav_items'

const NavItems = () => {
  const { t } = useTranslation()

  return (
    <div className="nav_items">
      {getNavItems(t).map(({ url, Icon, title }) => (
        <NavLink key={url} to={url} className="nav_item">
          <NavItem Icon={Icon} title={title} />
        </NavLink>
      ))}
    </div>
  )
}

export default NavItems
